import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/Help';
import { Box, Paper, Typography } from "@mui/material";
import React from 'react';
import { bulletParagraphStyle } from './LeaveDetails/styled';

interface IDisclaimerProps {
  onClick: () => void;
  title: string;
  text?: Array<string | JSX.Element>;
  bulletParagraph?: boolean
}

export const Disclaimer: React.FC<IDisclaimerProps> = ({ onClick, title, text, bulletParagraph }) => (
  <Box sx={{ position: "fixed", zIndex: "999", top: '56px', left: '50%', maxHeight: `calc(100vh - 56px)`, overflow: 'auto', ml: { xs: '-50%', md: 'calc(-75% / 2)', lg: '-600px' }, width: { xs: '100%', md: '75%', lg: '1200px' } }}>
    <Typography component="div" variant="popup-message" sx={{ m: 0 }}>
      <Paper data-automation="page-help-header" elevation={4} square sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HelpIcon sx={{ mr: 1 }} />
          <Typography component='span' variant="h6" sx={{ fontWeight: 'bold' }}>{title}</Typography>
        </Box>
        <CloseIcon onClick={onClick} sx={{ cursor: 'pointer' }} />
      </Paper>
      <Box sx={{ p: 2 }}>
        {Array.isArray(text)
          ? text.map((t, i) =>
            typeof t === "string"
              ? <Typography key={i} sx={{ ...(bulletParagraph && bulletParagraphStyle) }}>{t}</Typography>
              : <React.Fragment key={i}>{t}</React.Fragment>
          )
          : text}
      </Box>
    </Typography>
  </Box>
);
